import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { Router } from "@angular/router";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { ErrorUtil } from 'src/app/_utilities/error';

interface TypeOption {
  key: string;          // "#010"
  bgClass: string; 
  iconCode: string;     // CSS class for background
}

@Component({
    selector: 'app-choose-job-type',
    templateUrl: './choose-job-type.component.html',
    styleUrls: ['./choose-job-type.component.scss'],
    standalone: false
})
export class ChooseJobTypeComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  // Dummy data
   jobTypeOptions: any = []

  selectedJobType?: any;

  
  constructor(
    private router: Router,
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private globalJOServc: GlobalJobordersService,
    private errorUtil: ErrorUtil
  ) { 
    super();
    console.log(this.data, 'data printing in choose job type modal');
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.getJoTypes();
    console.log(this.data, 'data printing in choose job type modal');

  }
  //Language
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }

  nextCreate(data: any){
    this.selectedJobType = data;
    this.modalRef.hide();
    if (this.data && this.data === 'create-jo-template') {
      console.log(this.selectedJobType, 'selectedJobType printing in next create');
      setTimeout(() => this.router.navigate(['/dashboard/setup/jobOrder/templates/create-v2'], {queryParams: {joTypeId: this.selectedJobType.id}}), 0);
    }
    else{
      
       // Dynamically build queryParams object
        const queryParams: any = { joTypeId: this.selectedJobType.id };

        // Add checklistId if present
        if (this.data?.checklistRecordId) {
          queryParams.checkListRecordId = this.data.checklistRecordId;
        }
         if (this.data?.pmvId) {
          queryParams.pmvId = this.data.pmvId;
        }
        if(this.data?.origin == 'creareJobOrderFromBryntum'){
          queryParams.createDate = this.data.createDate;
          queryParams.owner = this.data.resource?.id;
          queryParams.origin = this.data.origin;
          queryParams.endDate = this.data.endDate ?? null;
        }

    // Example: add more dynamic params if needed
    if (this.selectedJobType.extraParams) {
      Object.assign(queryParams, this.selectedJobType.extraParams);
    }

    const urlTree = this.router.createUrlTree(['/dashboard/jobOrders/createStandardJobOrder'], { queryParams });
    const url = this.router.serializeUrl(urlTree);
    if (this.data?.origin === 'creareJobOrderFromBryntum') {
      window.open(url, '_blank');
    } else {
      this.router.navigate(['/dashboard/jobOrders/createStandardJobOrder'], {queryParams});
    }
    }
  }

  // Ina add to navigate directly to Setup: JO Type
  newType(){
     this.router.navigate(['/dashboard/setup/jobOrder/type-standalone']);
     this.modalRef.hide();
  }

  getJoTypes(){
    this.globalJOServc.getJobOrderTypes(true).subscribe((res: any) => {
      let jobOrderTypes: any = res;

      //jobTypeOptions
      console.log(jobOrderTypes)
      this.jobTypeOptions = jobOrderTypes;
       this.jobTypeOptions.sort((a:any, b:any) => a.order - b.order);

      this.jobTypeOptions.forEach((jot: any) => {
        jot.icon = jot.icon || 'fa-screwdriver-wrench'; // Default icon
       
      })

      jobOrderTypes.map ((jot: any, i: number) =>{
        
      });
      
      const theDefault = jobOrderTypes.find(
        (t: any) => t.isDefault === true
      );

      //if (this.mode === "add") {
        // if (theDefault) {
        //   this.recordForm.patchValue({ type: theDefault.id });
        // }
      //}

    }, 
    (err: any) =>{
      console.log(err, 'error in GET JO types api')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    });
  }
}
